@if (initialized) {
  <!--  h-screen overflow-auto surface-section-->
  <div class=" lg:p-4 p-2">
    <div class="sticky-stepper mb-3">
      <stepper [steps]="steps" [activeStep]="activeStep" (onStepChange)="handleStepChange($event)"></stepper>
    </div>

    <!-- ******************** STEP 1 ******************** -->
    <div class="mx-auto max-w-75rem surface-section lg:px-5 px-3 py-3 border-round-lg">
      @if (activeStep == 1) {
        <p-carousel
          #myCarousel
          [value]="infoSteps"
          [numVisible]="1"
          [numScroll]="1"
          [showNavigators]="false"
          [page]="currentCarouselIndex"
          indicatorStyleClass="custom-indicator"
          (onPage)="handleCarouselPageState($event)"
        >
          <ng-template let-info pTemplate="item">
            <div class="">
              <div class="product-item-content">
                <div class="my-3 text-center">
                  <img class="md:w-20rem w-14rem" [src]="info.uiImageUrl"/>
                </div>
                <div class="text-center">
                  <h4 class="mb-1 text-color text-center">{{ info.uiHeader }}</h4>
                  <h6 class="mt-0 mb-5 text-color-secondary text-center">{{ info.uiDescription }}</h6>
                </div>
              </div>
            </div>
          </ng-template>
        </p-carousel>
      }

      <!-- ******************** STEP 2 ******************** -->
      @if (activeStep == 2) {
        <upload-contract [onboardingDto]="onboardingDto">
          <ng-container>
            <div class="flex justify-content-center mb-5">
<!--      <span class="w-6rem h-6rem border-circle flex justify-content-center align-items-center bg-blue-100">-->
<!--            <div>-->
<!--              <i class="pi pi-cloud-upload text-blue-600 text-5xl"></i>-->
<!--               </div>-->
<!--      </span>-->
            </div>
            <div class="text-center mb-6">
              <div class="text-color text-3xl font-semibold mb-2">Bestehende Verträge</div>
              <span class="text-600 font-medium line-height-3 text-color-secondary">Lade dein Vertragsdokument hoch oder gib die Daten manuell ein.</span>
            </div>
          </ng-container>
        </upload-contract>
      }

      <!-- ******************** STEP 3 ******************** -->
      @if (activeStep == 3) {
        <questionnaire [onboardingDto]="onboardingDto" [questionerForm]="questionerForm"></questionnaire>
      }

      <!-- ******************** STEP 3 ******************** -->
      @if (activeStep == 4) {
        <div class="py-2 md:px-6 lg:px-8">
          <div class="border-round surface-card md:px-6 lg:py-6 py-3">

            <div class="text-center mb-5">
              <div class="text-color text-3xl font-semibold mb-2">Termin vereinbaren</div>
              <span *ngIf="showDescription" class="text-color-secondary">Wähle eine der folgenden Optionen, um einen Termin mit uns zu vereinbaren.</span>
            </div>

            <schedule-appointment-type
              [scheduleTypes]="onboardingDto?.scheduleTypes"
              [appointmentTypeId]="onboardingDto?.appointmentTypeId"
              [(selectedType)]="selectedScheduleType"
              (selectedTypeChange)="handleSelectedTypeChange($event)"
              (onSelectBookingPeriod)="handleSelectBookingPeriod($event)"
            ></schedule-appointment-type>

            <!--
              (onAppointmentScheduled)="handleAppointmentScheduled($event)"
              (onSelectScheduledType)="handleScheduleTypeSelect($event)"
            -->

          </div>
        </div>
      }

      <div class="flex mt-5" [ngClass]="activeStep > 1 ? 'justify-content-between' : 'justify-content-end'">
        @if (activeStep > 1) {
          <p-button (click)="gotoPreviousStep()" label="Zurück" severity="secondary" icon="pi pi-arrow-left"
                    [text]="true"></p-button>
        }
        <!--        <p-button (click)="gotoNextStep()" label="Weiter" icon="pi pi-arrow-right" iconPos="right"></p-button>-->
        <app-button [busy]="busy"
                    [label]="'Weiter'"
                    [icon]="'pi pi-arrow-right'"
                    (onClick)="gotoNextStep()">
        </app-button>
      </div>
    </div>
  </div>
}
